import { createRedesignEntry } from "../redesign-page-entry";

export default createRedesignEntry(() => import("./clinical-preferences-page"), {
  testId: "rd-prefs-loading",
  // «Мой профиль» → «Клинические предпочтения».
  shell: {
    breadcrumbRoot: { id: "redesign.profile.title", defaultMessage: "My profile", to: "/pages/my_account" },
    breadcrumbLeaf: { id: "redesign.prefs.title", defaultMessage: "Clinical preferences" },
  },
});
